export var gradientDirectionMap = {
  horizontal: '90deg',
  vertical: '0deg',
  'left-diagonal': '45deg',
  'right-diagonal': '135deg',
  'horizontal-reverse': '270deg',
  'vertical-reverse': '180deg',
  'left-diagonal-reverse': '225deg',
  'right-diagonal-reverse': '315deg'
};
export var gradientOptions = ['magic-primary', 'magic-primary-dark', 'negative-magic', 'primary-positive', 'warning-negative', 'positive', 'primary'];